import { Button, Col, Layout, Row, message } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { cachedBcpEventService } from '../../services/CachedBcpEventService';

const { Header } = Layout;

const TeamAdminHeader = () => {
  const handleClearCache = () => {
    cachedBcpEventService.clearCache();
    message.success('Cache cleared successfully. Please refresh the page.');
  };

  return (
    <Header>
      <Row gutter={16} justify={'space-between'}>
        <Col span={2}></Col>
        <Col span={20} style={{ textAlign: 'right' }}>
          <Button 
            icon={<DeleteOutlined />} 
            onClick={handleClearCache}
            ghost="true"
          >
            Clear Cache
          </Button>
        </Col>
      </Row>
    </Header>
  );
};

export default TeamAdminHeader;
